import React from "react";
import { getFieldValue } from "@sitecore-jss/sitecore-jss-react";
import styled from "styled-components";
import cx from "classnames";
import pageTypes from "utils/pageTypes";
import breakpoints from "utils/breakpoints";
import { Heading, Copy } from "components/components/atoms";
import { isValidTitle } from "utils/validateTitle";

const SectionHeading = styled.h3.attrs({
  className: "font-trade-gothic-20 text-3xl mb-1 md:mb-3",
})``;

const HeadingContainer = styled.div`
  @media ${breakpoints.lg} {
    max-width: 35rem;
  }
`;

const CopyContainer = styled.div`
  @media ${breakpoints.lg} {
    max-width: 45rem;
  }
`;

const FormsTitle = ({ fields, hasNoSectionsLeft = false }) => {
  const title = getFieldValue(fields, "title");
  const description = getFieldValue(fields, "description");
  const currentPageType = getFieldValue(fields, "currentPageType");

  return (
    <div
      className={cx("flex flex-col w-full text-mattamy-blue", {
        "justify-center items-center":
          currentPageType === pageTypes.MarketPage ||
          currentPageType === pageTypes.SupportPage ||
          hasNoSectionsLeft,
        "justify-left": !currentPageType === pageTypes.MarketPage,
      })}
    >
      {(currentPageType === pageTypes.MarketPage || title) &&
        isValidTitle(title) && <SectionHeading>{title}</SectionHeading>}
      {currentPageType === pageTypes.SupportPage && (
        <>
          <HeadingContainer>
            <Heading as="h2" className="lg:my-1">
              {title}
            </Heading>
          </HeadingContainer>
          <CopyContainer>
            <Copy className="leading-relaxed">{description}</Copy>
          </CopyContainer>
        </>
      )}
      <CopyContainer>
        <Copy className="leading-relaxed">
          {"Required fields are marked with *"}
        </Copy>
      </CopyContainer>
    </div>
  );
};

export default FormsTitle;
